import React from 'react'
import './svg.css'
import ImageUpload from './svgs/ImageUpload'
import Server from './svgs/Server'

export default function SVG({ svg, children }) {

    const svgs = {
        'image upload': <ImageUpload />,
        'server': <Server />
    }

    return svgs[svg] ? (
        <div className='svg__wrapper'>
            <div className='svg__container'>
                <div className='svg__children'>{ children }</div>
                <div className='svg__image'>{ svgs[svg] }</div>
            </div>
        </div>
    ) : null
}



// WEBPACK FOOTER //
// ./src/components/SVG/index.js